<template>
  <v-container grid-list-xl fluid>
    <v-layout row wrap>
      <v-flex sm6>
        <div class="headline green--text text--darken-4 font-weight-medium">
          Doctors
        </div>
      </v-flex>
      <v-flex lg12 sm12 xs12>
        <v-card>
          <v-toolbar card color="transparent">
            <v-btn color="primary" @click="showAddDlg">
              <v-icon class="iconText">fa fa-plus</v-icon>
              New Doctor
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn @click="api_get" :disabled="loading">
              <v-icon class="iconText">fa fa-sync</v-icon>
              Refresh
            </v-btn>
          </v-toolbar>
          <v-divider></v-divider>
          <v-card-text class="pa-0">
            <v-data-table
              :headers="headers"
              :items="doctors"
              item-key="Id"
              :rows-per-page-items="rows_per_page"
              :loading="loading"
              class="elevation-1"
            >
              <template slot="items" slot-scope="props">
                <tr>
                  <td>{{ props.item.RegistrationNumber }}</td>
                  <td>{{ props.item.FullName }}</td>
                  <td>{{ props.item.Mobile }}</td>
                  <td>{{ props.item.Qualification }}</td>
                  <td style="text-align: center">
                    <button
                      type="button"
                      class="linkBtn"
                      @click="showViewDlg(props.item)"
                    >
                      View
                    </button>
                    <button
                      type="button"
                      class="linkBtn"
                      @click="showEditDlg(props.item)"
                    >
                      Edit
                    </button>
                    <button
                      type="button"
                      class="linkBtn"
                      @click="showResetPasswordDlg(props.item)"
                    >
                      Reset Password
                    </button>

                    <!--<v-btn color="blue" style="text-decoration: underline" flat>-->
                    <!--Add-->
                    <!--</v-btn>-->
                    <!--<v-btn small icon depressed>-->
                    <!--<v-icon color="grey darken-1">fa fa-trash</v-icon>-->
                    <!--</v-btn>-->
                  </td>
                </tr>
              </template>
            </v-data-table>
            <div>
              <v-dialog
                v-model="dlgShow"
                scrollable
                persistent
                max-width="400px"
              >
                <v-card v-if="showResetPassword">
                  <v-card-title>
                    <div class="title font-weight-medium">
                      Change password
                    </div>
                  </v-card-title>
                  <v-card-text>
                    <v-text-field
                      :type="pwd2 ? 'text' : 'password'"
                      :append-icon="pwd2 ? 'fa fa-eye' : 'fa fa-eye-slash'"
                      @click:append="pwd2 = !pwd2"
                      v-model.trim="dlgModel.NewPwd"
                      name="newPwd"
                      label="New Password:"
                      v-validate="{ required: true }"
                      :error="!!errors.has('newPwd')"
                      :error-messages="errors.first('newPwd')"
                    ></v-text-field>
                    <v-text-field
                      :type="pwd3 ? 'text' : 'password'"
                      :append-icon="pwd3 ? 'fa fa-eye' : 'fa fa-eye-slash'"
                      @click:append="pwd3 = !pwd3"
                      v-model.trim="dlgModel.ConPwd"
                      name="conPwd"
                      label="Confirm Password:"
                      v-validate="{ required: true }"
                      :error="!!errors.has('conPwd')"
                      :error-messages="errors.first('conPwd')"
                    ></v-text-field>
                    <div v-show="submit.error">
                      <v-list two-line>
                        <v-list-tile>
                          <span class="red--text">{{ submit.message }}</span>
                        </v-list-tile>
                      </v-list>
                    </div>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      flat
                      :disabled="submit.working"
                      @click.native="clearDlg"
                      >Close</v-btn
                    >
                    <v-btn
                      color="blue darken-1"
                      flat
                      :loading="submit.working"
                      @click.native="resetPassword"
                      >Save</v-btn
                    >
                  </v-card-actions>
                </v-card>
                <v-card v-else>
                  <v-card-title>
                    <div class="title font-weight-medium">
                      {{ dlgTitle }}
                    </div>
                  </v-card-title>
                  <v-card-text>
                    <v-text-field
                      v-model.trim="dlgModel.FullName"
                      name="fName"
                      label="Full Name:"
                      :disabled="dlgType !== 0"
                      v-validate="{ required: true }"
                      :error="!!errors.has('fName')"
                      :error-messages="errors.first('fName')"
                    ></v-text-field>
                    <v-text-field
                      v-model.trim="dlgModel.Email"
                      name="email"
                      label="Email:"
                      :disabled="dlgType !== 0"
                      v-validate="{ required: true }"
                      :error="!!errors.has('email')"
                      :error-messages="errors.first('email')"
                    ></v-text-field>
                    <v-text-field
                      v-model.trim="dlgModel.Mobile"
                      name="mobile"
                      label="Mobile Number:"
                      :disabled="dlgType === 2"
                      v-validate="{ required: true }"
                      :error="!!errors.has('mobile')"
                      :error-messages="errors.first('mobile')"
                    ></v-text-field>
                    <v-textarea
                      v-model.trim="dlgModel.Address"
                      name="address"
                      label="Address:"
                      :disabled="dlgType === 2"
                      v-validate="{ required: true }"
                      :error="!!errors.has('address')"
                      :error-messages="errors.first('address')"
                      no-resize
                      rows="2"
                    ></v-textarea>
                    <v-text-field
                      v-model.trim="dlgModel.RegistrationNumber"
                      name="rNo"
                      label="Registration Number:"
                      :disabled="dlgType !== 0"
                      v-validate="{ required: true }"
                      :error="!!errors.has('rNo')"
                      :error-messages="errors.first('rNo')"
                    ></v-text-field>
                    <v-text-field
                      v-model.trim="dlgModel.Qualification"
                      name="qualification"
                      label="Qualification:"
                      :disabled="dlgType === 2"
                      v-validate="{ required: true }"
                      :error="!!errors.has('qualification')"
                      :error-messages="errors.first('qualification')"
                    ></v-text-field>
                    <v-text-field
                      v-model.trim="dlgModel.Specialization"
                      name="spl"
                      label="Specialization:"
                      :disabled="dlgType === 2"
                    ></v-text-field>
                    <div v-show="submit.error">
                      <v-list two-line>
                        <v-list-tile>
                          <span class="red--text">{{ submit.message }}</span>
                        </v-list-tile>
                      </v-list>
                    </div>
                  </v-card-text>
                  <v-divider></v-divider>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      flat
                      :disabled="submit.working"
                      @click.native="clearDlg"
                      >Close</v-btn
                    >
                    <v-btn
                      v-show="dlgType !== 2"
                      color="blue darken-1"
                      flat
                      :loading="submit.working"
                      @click.native="saveDlg"
                      >Save</v-btn
                    >
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </div>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import WebH from "../../api/web";
export default {
  created() {
    this.api_get();
  },
  data() {
    return {
      rows_per_page: [10, 25, 50],
      headers: [
        {
          text: "Registration No.",
          value: "RegistrationNumber",
          sortable: true,
          width: "20%"
        },
        { text: "Name", value: "FullName", sortable: true, width: "20%" },
        { text: "Mobile", value: "Mobile", sortable: true, width: "20%" },
        {
          text: "Qualification",
          value: "Qualification",
          sortable: true,
          width: "20%"
        },
        {
          text: "Actions",
          value: "",
          sortable: false,
          width: "20%",
          align: "center"
        }
      ],
      doctors: [],
      loading: false,
      dlgShow: false,
      pwd2: false,
      pwd3: false,
      showResetPassword: false,
      dlgType: 0,
      dlgModel: {},
      dlgTitle: "",
      submit: {
        error: false,
        working: false,
        message: ""
      }
    };
  },
  methods: {
    clearDlg() {
      this.submit = {
        error: false,
        completed: false,
        message: ""
      };
      this.dlgShow = false;
      this.showResetPassword = false;
    },
    showAddDlg() {
      this.dlgTitle = "New Doctor";
      this.dlgType = 0;
      this.dlgModel = {
        FullName: "",
        Email: "",
        Mobile: "",
        Address: "",
        RegistrationNumber: "",
        Qualification: "",
        Specialization: ""
      };
      this.dlgShow = true;
    },
    showEditDlg(item) {
      this.dlgTitle = "Update Doctor";
      this.dlgType = 1;
      this.dlgModel = item;
      this.dlgShow = true;
    },
    showViewDlg(item) {
      this.dlgTitle = "Doctor info";
      this.dlgType = 2;
      this.dlgModel = item;
      this.dlgShow = true;
    },
    showResetPasswordDlg(item) {
      this.showResetPassword = true;
      this.dlgModel = {
        Email: item.Email,
        NewPwd: "",
        ConPwd: ""
      };
      this.dlgShow = true;
    },
    async saveDlg() {
      const res = await this.$validator.validateAll();
      if (!res) return;
      this.submit.working = true;
      if (this.dlgType === 0) {
        this.api_newDoc(this.dlgModel);
      } else if (this.dlgType === 1) {
        const newData = {
          Id: this.dlgModel.Id,
          Mobile: this.dlgModel.Mobile,
          Address: this.dlgModel.Address,
          Qualification: this.dlgModel.Qualification,
          Specialization: this.dlgModel.Specialization
        };
        this.api_editDoc(newData);
      }
    },
    async resetPassword() {
      const res = await this.$validator.validateAll();
      if (!res) return;
      this.submit.working = true;
      this.api_resetPassword({
        Email: this.dlgModel.Email,
        Password: this.dlgModel.NewPwd
      });
    },
    async api_newDoc(data) {
      const res = await WebH.Post("/doctors", data);
      this.submit.working = false;
      if (res.Success) {
        this.doctors.push(res.Data);
        this.$notify({ type: "info", text: "Successfully added new doctor" });
        this.clearDlg();
      } else {
        this.submit.error = true;
        this.submit.message = res.Data;
      }
    },
    async api_editDoc(data) {
      const res = await WebH.Put("/doctors/" + data.Id, data);
      this.submit.working = false;
      if (res.Success) {
        this.$notify({ type: "info", text: "Successfully updated the doctor" });
        this.clearDlg();
      } else {
        this.submit.error = true;
        this.submit.message = res.Data;
      }
    },
    async api_get() {
      this.loading = true;
      this.doctors = [];
      const res = await WebH.Get("/doctors", "doctors");
      if (res.Success) {
        this.doctors = res.Data;
      }
      this.loading = false;
    },
    async api_resetPassword(data) {
      const res = await WebH.Put(`/users/password/${data.Email}`, data);
      this.submit.working = false;
      if (res.Success) {
        this.$notify({
          type: "info",
          text: "Successfully changed the password"
        });
        this.clearDlg();
      } else {
        this.submit.error = true;
        this.submit.message = res.Data;
      }
    }
  }
};
</script>

<style scoped></style>
